import request from '@/utils/request'

export function login(loginName, password) { 
    return request({
        url:'/login',
        method: 'get',
        params:{
            loginName,
            password
        }
    })
 }

 export function adminLogin(adminCode, adminMobile) { 
    return request({
        url:'/adminLogin',
        method: 'post',
        params:{
            adminMobile,
            adminCode
            
        }
    })
 }
 export function getRouter() {
    return request({
      url: '/menu',
      method: 'get',
    })
  }
 
  export function logout() { 
    return request({
        url:'/logout',
        method: 'get',
      
    })
 }
 export function getUser() { 
  return request({
      url:'/system/loginUser',
      method: 'get',
  })
}
 export function changePass(params) { 
  return request({
      url:'/system/updatePass',
      method: 'PATCH',
      params:params
  })
}
export function saveRegister(data) {
  return request({
      url: '/register',
      method: 'post',
      data:data
  })
}
export function saveOtherRegister(data) {
  return request({
      url: '/smarunite/samrMakeUpUser',
      method: 'post',
      data:data
  })
}

export function pwdPrompt(params) { 
  return request({
      url:'/system/sysUser/prompt',
      method: 'GET',
      params:params
  })
}

//
export function sendCode(userType, userName,sendType,sendTool) { 
  return request({
      url:'/sms/sendCode',
      method: 'get',
      params:{
        userType, userName,sendType,sendTool
      }
  })
}

